import React, { Component } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "../../styles/assets/liveAlert.scss";
import axios from "axios";
import SensorConfigPanel from "./SensorConfigPanel";
import Layout from "../../Layout/layout";

// Constants for sensors configuration
const SENSORS = {
  A: {
    key: "TempA",
    label: "Temperature Sensor A",
  },
  B: {
    key: "TempB",
    label: "Temperature Sensor B",
  },
};

class LiveAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetId: this.props.match.params.id,
      assetName: "",
      loading: true,
      activeKey: SENSORS.A.key,
    };
  }

  componentDidMount() {
    this.loadAssetInfo();
  }

  loadAssetInfo = async () => {
    try {
      const response = await axios.post(
        `/api/assets/selectasset/${this.state.assetId}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        assetName: response.data.name || "Unknown Asset",
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching asset information:", error);
      this.setState({ loading: false });
    }
  };

  handleTabChange = (key) => {
    this.setState({ activeKey: key });
  };

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }

    return (
      <React.Fragment>
        <Layout>
          <div className="contentBody">
            <div className="formContainer">
              <div className="d-flex align-items-center">
                <Link to="/assets" className="btn btn-link">
                  <i className="fa fa-arrow-left mr-2"></i>
                </Link>
                <h3 className="m-0">Live Alert Configuration</h3>
                <span>{this.state.assetName}</span>
              </div>
              <hr />

              <div className="formGroupSub">
                <Tab.Container
                  id="sensor-tabs"
                  activeKey={this.state.activeKey}
                  onSelect={this.handleTabChange}
                >
                  <Row>
                    <Col sm={2}>
                      <h5 className="mb-3">Configurations</h5>
                      <Nav variant="pills" className="flex-column">
                        {Object.values(SENSORS).map((sensor) => (
                          <Nav.Item key={sensor.key}>
                            <Nav.Link eventKey={sensor.key}>
                              {sensor.label}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                      </Nav>
                    </Col>
                    <Col sm={10}>
                      <Tab.Content>
                        {Object.values(SENSORS).map((sensor) => (
                          <Tab.Pane key={sensor.key} eventKey={sensor.key}>
                            <SensorConfigPanel
                              assetId={this.state.assetId}
                              sensorType={sensor.key}
                              sensorLabel={sensor.label}
                            />
                          </Tab.Pane>
                        ))}
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(LiveAlert);
